function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6677 8.90625H0.84375C0.42975 8.90625 0.09375 8.57025 0.09375 8.15625C0.09375 7.74225 0.42975 7.40625 0.84375 7.40625H18.6677C19.0817 7.40625 19.4177 7.74225 19.4177 8.15625C19.4177 8.57025 19.0817 8.90625 18.6677 8.90625Z",
  fill: "#9BA0AD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1993 12.8086C13.7853 12.8086 13.4453 12.4726 13.4453 12.0586C13.4453 11.6446 13.7763 11.3086 14.1903 11.3086H14.1993C14.6133 11.3086 14.9493 11.6446 14.9493 12.0586C14.9493 12.4726 14.6133 12.8086 14.1993 12.8086Z",
  fill: "#9BA0AD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.76181 12.8086C9.34781 12.8086 9.00781 12.4726 9.00781 12.0586C9.00781 11.6446 9.33881 11.3086 9.75281 11.3086H9.76181C10.1758 11.3086 10.5118 11.6446 10.5118 12.0586C10.5118 12.4726 10.1758 12.8086 9.76181 12.8086Z",
  fill: "#9BA0AD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.3175 12.8086C4.9035 12.8086 4.5625 12.4726 4.5625 12.0586C4.5625 11.6446 4.8945 11.3086 5.3085 11.3086H5.3175C5.7315 11.3086 6.0675 11.6446 6.0675 12.0586C6.0675 12.4726 5.7315 12.8086 5.3175 12.8086Z",
  fill: "#9BA0AD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1993 16.6953C13.7853 16.6953 13.4453 16.3593 13.4453 15.9453C13.4453 15.5313 13.7763 15.1953 14.1903 15.1953H14.1993C14.6133 15.1953 14.9493 15.5313 14.9493 15.9453C14.9493 16.3593 14.6133 16.6953 14.1993 16.6953Z",
  fill: "#9BA0AD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.76181 16.6953C9.34781 16.6953 9.00781 16.3593 9.00781 15.9453C9.00781 15.5313 9.33881 15.1953 9.75281 15.1953H9.76181C10.1758 15.1953 10.5118 15.5313 10.5118 15.9453C10.5118 16.3593 10.1758 16.6953 9.76181 16.6953Z",
  fill: "#9BA0AD"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.3175 16.6963C4.9035 16.6963 4.5625 16.3603 4.5625 15.9463C4.5625 15.5323 4.8945 15.1963 5.3085 15.1963H5.3175C5.7315 15.1963 6.0675 15.5323 6.0675 15.9463C6.0675 16.3603 5.7315 16.6963 5.3175 16.6963Z",
  fill: "#9BA0AD"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.793 4.791C13.379 4.791 13.043 4.455 13.043 4.041V0.75C13.043 0.336 13.379 0 13.793 0C14.207 0 14.543 0.336 14.543 0.75V4.041C14.543 4.455 14.207 4.791 13.793 4.791Z",
  fill: "#9BA0AD"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.71484 4.791C5.30084 4.791 4.96484 4.455 4.96484 4.041V0.75C4.96484 0.336 5.30084 0 5.71484 0C6.12884 0 6.46484 0.336 6.46484 0.75V4.041C6.46484 4.455 6.12884 4.791 5.71484 4.791Z",
  fill: "#9BA0AD"
});

var _ref11 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 1,
  width: 20,
  height: 21
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1.5791H19.5V21.5H0V1.5791Z",
  fill: "white"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.521 3.0791C2.928 3.0791 1.5 4.4621 1.5 6.9731V16.0221C1.5 18.5881 2.928 20.0001 5.521 20.0001H13.979C16.572 20.0001 18 18.6141 18 16.0981V6.9731C18.004 5.7381 17.672 4.7781 17.013 4.1181C16.335 3.4381 15.29 3.0791 13.988 3.0791H5.521ZM13.979 21.5001H5.521C2.116 21.5001 0 19.4011 0 16.0221V6.9731C0 3.6451 2.116 1.5791 5.521 1.5791H13.988C15.697 1.5791 17.11 2.0911 18.075 3.0581C19.012 3.9991 19.505 5.3521 19.5 6.9751V16.0981C19.5 19.4301 17.384 21.5001 13.979 21.5001Z",
  fill: "#9BA0AD"
}));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.0807bd5d.svg";
export { ForwardRef as ReactComponent };